import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()
  const [api] = useState(() => ({
    outOfStorageSpaceTitle: translate({
      id: 'outOfStorageSpaceModal.title',
    }),

    navigateToTerritorySettingsButton: translate({
      id: 'outOfStorageSpaceModal.footer.navigateToTerritorySettingsButton',
    }),
    getStorageTipsButton: translate({ id: 'outOfStorageSpaceModal.footer.getStorageTipsButton' }),
    closeButton: translate({ id: 'outOfStorageSpaceModal.footer.closeButton' }),
    prevStepButton: translate({ id: 'outOfStorageSpaceModal.footer.prevStepButton' }),

    operationalDescription: translate({
      id: 'outOfStorageSpaceModal.details.operation.description',
    }),
    simulationDescription: translate({
      id: 'outOfStorageSpaceModal.details.simulation.description',
    }),

    ordersText: translate({ id: 'outOfStorageSpaceModal.details.ordersText' }),
    explanationPoint1: translate({ id: 'outOfStorageSpaceModal.details.operation.point1' }),
    explanationPoint2: translate({ id: 'outOfStorageSpaceModal.details.operation.point2' }),
    explanationPoint2Alternative: (date: string) =>
      translate({
        id: 'outOfStorageSpaceModal.details.operation.point2.alternative',
        values: { date },
      }),

    storageTipsDescription: translate({
      id: 'outOfStorageSpaceModal.options.operation.storageTips.description',
    }),
    option1: translate({ id: 'outOfStorageSpaceModal.options.operation.storageTips.option1' }),
    option2: translate({ id: 'outOfStorageSpaceModal.options.operation.storageTips.option2' }),
    option3: translate({ id: 'outOfStorageSpaceModal.options.operation.storageTips.option3' }),
  }))

  return api
}
